var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_282_4381)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 24.5C33.9069 24.5 26 29.1125 26 35V53C26 58.8875 33.9069 63.5 44 63.5C54.0931 63.5 62 58.8875 62 53V35C62 29.1125 54.0931 24.5 44 24.5ZM59 44C59 45.8037 57.5225 47.6431 54.9481 49.0475C52.0494 50.6281 48.1606 51.5 44 51.5C39.8394 51.5 35.9506 50.6281 33.0519 49.0475C30.4775 47.6431 29 45.8037 29 44V40.88C32.1988 43.6925 37.6681 45.5 44 45.5C50.3319 45.5 55.8013 43.685 59 40.88V44ZM33.0519 29.9525C35.9506 28.3719 39.8394 27.5 44 27.5C48.1606 27.5 52.0494 28.3719 54.9481 29.9525C57.5225 31.3569 59 33.1962 59 35C59 36.8038 57.5225 38.6431 54.9481 40.0475C52.0494 41.6281 48.1606 42.5 44 42.5C39.8394 42.5 35.9506 41.6281 33.0519 40.0475C30.4775 38.6431 29 36.8038 29 35C29 33.1962 30.4775 31.3569 33.0519 29.9525ZM54.9481 58.0475C52.0494 59.6281 48.1606 60.5 44 60.5C39.8394 60.5 35.9506 59.6281 33.0519 58.0475C30.4775 56.6431 29 54.8037 29 53V49.88C32.1988 52.6925 37.6681 54.5 44 54.5C50.3319 54.5 55.8013 52.685 59 49.88V53C59 54.8037 57.5225 56.6431 54.9481 58.0475Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_4381",
    x1: 0,
    y1: 45.5,
    x2: 90,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR1);
export default __webpack_public_path__ + "static/media/r-1.6904c12a2cb3a7ddcd2d614be815eeb8.svg";
export { ForwardRef as ReactComponent };